import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(pure);

const button = enhance(({ params, onClickAction, status, disabled }) => {
  let statusText;
  if (status) {
    statusText = `実行中`;
  } else {
    statusText = `停止中`;
  }
  return (
    <Button
      disabled={disabled}
      color="primary"
      onClick={() => {
        onClickAction(params);
      }}
    >
      {statusText}
    </Button>
  );
});

export default withStyles(styles)(button);
